import React from 'react';
import {
  Shield,
  Clock,
  MessageCircle,
  Code2,
  Sparkles,
  HeartHandshake
} from 'lucide-react';

const commitments = [
  {
    icon: Clock,
    title: "Respuesta en 2 Horas",
    description: "Nos comprometemos a responder cada consulta en menos de 2 horas en horario laboral."
  },
  {
    icon: Shield,
    title: "Garantia de Satisfaccion",
    description: "Si no estas conforme con el resultado, trabajamos hasta que lo estes sin costo adicional."
  },
  {
    icon: MessageCircle,
    title: "Comunicacion Directa",
    description: "Hablas directamente con quien desarrolla tu proyecto, sin intermediarios."
  },
  {
    icon: Code2,
    title: "Codigo de Calidad",
    description: "Entregamos codigo limpio, documentado y con buenas practicas de desarrollo."
  },
  {
    icon: Sparkles,
    title: "Tecnologia Moderna",
    description: "Usamos las herramientas mas actuales: React, Python, IA generativa y mas."
  },
  {
    icon: HeartHandshake,
    title: "Precios Transparentes",
    description: "Presupuesto detallado antes de empezar, sin sorpresas ni costos ocultos."
  }
];

export const CredibilitySection = () => {
  return (
    <section className="py-24 lg:py-32 bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-accent uppercase tracking-[0.2em] mb-4 block">
            Nuestro Compromiso
          </span>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-background leading-tight mb-4 text-balance">
            Por que elegirnos
          </h2>
          <p className="text-background/60 text-lg max-w-2xl mx-auto leading-relaxed">
            Somos un equipo con ganas de demostrar nuestro valor. Por eso nos comprometemos a:
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {commitments.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl border border-background/10 hover:border-accent/30 transition-all duration-500 hover:bg-background/5"
              >
                <div className="w-12 h-12 rounded-xl bg-background/10 flex items-center justify-center mb-6 group-hover:bg-accent/20 transition-colors duration-300">
                  <IconComponent className="h-5 w-5 text-accent" />
                </div>
                <h3 className="font-semibold text-lg text-background mb-2">
                  {item.title}
                </h3>
                <p className="text-background/50 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
